const PATH = "/api/v1/auth";

const ENDPOINTS = {
  AUTH_LOGIN_MOBILE_OTP: "/login/mobile/otp/",
  AUTH_REQUEST_OTP_ZOSTEL: "/request-otp/zostel/",
  AUTH_LOGIN_MOBILE: "/login/mobile/",
  AUTH_ACTIVATE: "/activate/",
  AUTH_REQUEST_OTP_EMAIL: "/request-otp/email/",
  AUTH_USER_EMAILS: "/user/emails/",
  AUTH_USER_MERGE: "/user/merge/",
};

export type ZoAuthEndpoints = keyof typeof ENDPOINTS;
export const ZoAuthCollection = { PATH, ENDPOINTS };
